import React from 'react'
import {Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import {
    renderFieldCpfCnpj,    
    renderFieldText,
    renderFieldTelefone,
    required,    
    telefone,
    apenasNumero,
    validarCpfCnpj,
    renderFieldNumber
} from '../../util/inputs'

import cadastrarPessoa from '../../actions/pessoa/cadastrarPessoa';
import {showSuccessMsg} from '../../util/messagesUtil';

const selector = formValueSelector('formularioCadastroPessoa');

export class ModalCadastroPessoa extends React.Component {
    fecharModal() {
        $('#modalCadastrarPessoa')
            .modal('hide');
        $('#modalCadastrarPessoa')
            .hide();
        $('.modal-backdrop')
            .hide();
    }

    submit(values) {
        const parametros = {
            nome: values.nome,            
            telefone: values.telefone,
            tipoPessoa: apenasNumero(values.cpfCnpj).length === 11 ? 'PF' : 'PJ',
            cpfCnpj: values.cpfCnpj.trim(),
            inscricaoEstadual: values.ie

        };
        this.props.cadastrarPessoa(parametros).then(() => {
            showSuccessMsg('Pessoa cadastrada com sucesso');
            this.fecharModal();
            this.props.buscarPessoa(parametros.cpfCnpj)
        })
    }

    tipoPessoa() {        
        return apenasNumero(this.props.cpfCnpj).length === 11 ? 'PF' : 'PJ'        
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarPessoa' role='dialog'
                 aria-labelledby='modalCadastrarPessoa' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Cadastro de Pessoa</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit.bind(this))}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="nome" type="text" validate={[required]} required={true}
                                               component={renderFieldText} label="Nome Completo:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <Field name="cpfCnpj" type="text" validate={[required, validarCpfCnpj]}
                                           component={renderFieldCpfCnpj} label="CPF/CNPJ:"
                                           css="form-control col-md-6"/>
                                </div>
                                
                                <div className="form-group">
                                    <Field name="telefone" type="text" validate={[required, telefone]}
                                           component={renderFieldTelefone}
                                           css="form-control col-md-6" label="Telefone"/>
                                </div>
                                {this.tipoPessoa() == 'PJ' ? <div className="form-group">                                    
                                        <Field name="ie" type="text" component={renderFieldNumber} formatacao="##############"                                            
                                            label="Inscrição Estadual:"
                                            css="form-control col-md-6" readOnly={false}/>                                    
                                </div>: ''}
                                <div className="modal-footer mt-4">
                                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                                            data-dismiss="modal">Cancelar
                                    </button>
                                    <button type="submit" disabled={invalid || submitting || pristine}
                                            className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        cadastrarPessoa
    }, dispatch)
);

const mapStateToProps = state => {
    return {
        cpfCnpj: selector(state, 'cpfCnpj')
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroPessoa',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(ModalCadastroPessoa));
